import { pickerToDayBounds } from "../../../utils/timezone/dayBounds";
import { getCompanyTimezone } from "../../../utils/timezone/teamTimezone";
import dayjsTZ from "../../../utils/dayjs";

export const onFilter = async ({
  gridApi,
  column,
  current,
  type = "equals",
}) => {
  const currentValues = Array.isArray(current)
    ? { values: [...current] }
    : { filter: current };

  type === "set"
    ? await gridApi.getColumnFilterInstance(column).then((comp) => {
        comp.getChildFilterInstance(1).setModel({
          type,
          ...currentValues,
        });
      })
    : await gridApi.getColumnFilterInstance(column).then((comp) => {
        comp.setModel({
          type,
          ...currentValues,
        });
      });
  gridApi.onFilterChanged();
};

export const onDateFilter = async ({ gridApi, column, dateArray }) => {
  const tz = getCompanyTimezone();
  const start = pickerToDayBounds(dateArray[0], tz);
  const end = pickerToDayBounds(dateArray[1], tz);
  await gridApi.getColumnFilterInstance(column).then((comp) => {
    comp.setModel({
      type: "inRange",
      filterType: "date",
      dateForm: start
        ? dayjsTZ(start.startMs).format("YYYY-MM-DD HH:mm:ss")
        : undefined,
      dateTo: end
        ? dayjsTZ(end.endMs).format("YYYY-MM-DD HH:mm:ss")
        : undefined,
    });
  });
  gridApi.onFilterChanged();
};

export const clearFilter = async ({ gridApi, column }) => {
  await gridApi.getColumnFilterInstance(column)?.then((comp) => {
    comp.setModel(null);
  });
  gridApi.onFilterChanged();
};

export const clearAllFilters = ({ filters, gridApi }) => {
  filters.map((column) => clearFilter({ gridApi, column }));
};
